var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumeratorInsightsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 385.34 94.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#004a52;}.cls-2{fill:url(#New_Gradient_Swatch_copy_2-2);}.cls-2,.cls-3{opacity:.5;}.cls-3{fill:url(#New_Gradient_Swatch_copy_2);}.cls-4{fill:url(#New_Gradient_Swatch_copy_2-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2",
    x1: -10.1,
    y1: 74.78,
    x2: 44.13,
    y2: 20.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e26c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#00e270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#02e57d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#04e992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#08eeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09f0b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-2",
    x1: 50.72,
    y1: 74.78,
    x2: 104.95,
    y2: 20.55,
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-3",
    x1: 4.98,
    y1: 89.87,
    x2: 89.63,
    y2: 5.22,
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m189.99,36.29c0,7.91-5.58,11.32-11.84,11.32s-11.86-3.41-11.86-11.32v-11.43c0-1.86,1.5-3.36,3.36-3.36h.03c1.86,0,3.36,1.5,3.36,3.36v10.84c0,4.01,2.2,5.64,5.12,5.64s5.12-1.63,5.12-5.64v-10.84c0-1.86,1.5-3.36,3.36-3.36h0c1.86,0,3.36,1.5,3.36,3.36v11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m236.03,31.02v12.88c0,1.86-1.5,3.36-3.36,3.36h0c-1.86,0-3.36-1.5-3.36-3.36v-10.71c0-3.62-1.84-5.61-4.89-5.61s-5.3,1.89-5.3,5.66v10.66c0,1.86-1.5,3.36-3.36,3.36h-.03c-1.86,0-3.36-1.5-3.36-3.36v-10.71c0-3.62-1.81-5.61-4.89-5.61-2.9,0-5.3,1.89-5.3,5.66v10.66c0,1.86-1.5,3.36-3.36,3.36h-.03c-1.86,0-3.36-1.5-3.36-3.36v-19.13c0-1.81,1.47-3.28,3.28-3.28h0c1.81,0,3.28,1.47,3.28,3.28v.09c1.78-2.66,4.52-3.62,7.37-3.62,3.62,0,6.59,1.63,8.27,4.29,1.94-3.18,5.22-4.29,8.5-4.29,5.89,0,9.87,3.96,9.87,9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m264.19,34.4s0,.02,0,.02c0,1.25-1.02,2.25-2.27,2.25h-15.62c.72,3.62,3.26,5.2,6.44,5.2,1.49,0,3.07-.42,4.5-1.17,1.16-.62,2.59-.4,3.48.57l.16.18c1.26,1.38.86,3.57-.8,4.44-2.26,1.18-4.85,1.73-7.72,1.73-7.68,0-13-5.22-13-13.11s5.17-13.26,12.67-13.26,12.15,5.35,12.18,13.16Zm-17.86-2.33h11.09c-.62-3.21-2.56-5.01-5.45-5.01-3.18,0-5.04,1.91-5.64,5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m284.66,24.69v.04c-.27,1.68-1.81,2.87-3.5,2.68-.39-.04-.77-.06-1.14-.06-3.13,0-5.27,2.24-5.27,5.96v10.87c0,1.86-1.51,3.37-3.37,3.37h0c-1.86,0-3.37-1.51-3.37-3.37v-19.53c0-1.76,1.43-3.19,3.19-3.19h.17c1.76,0,3.19,1.43,3.19,3.19h0c1.58-2.35,3.98-3.41,7.06-3.41.05,0,.11,0,.16,0,1.81.02,3.18,1.65,2.89,3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m308.55,47.56h0c-1.82,0-3.3-1.48-3.3-3.3v-.06c-1.63,2.02-4.06,3.41-7.5,3.41-6.9,0-12.12-5.66-12.12-13.18s5.22-13.18,12.12-13.18c3.44,0,5.84,1.4,7.5,3.44h0c0-1.79,1.45-3.24,3.24-3.24h.11c1.79,0,3.24,1.45,3.24,3.24v19.58c0,1.82-1.48,3.3-3.3,3.3Zm-16.01-13.13c0,3.83,2.51,6.9,6.46,6.9s6.46-2.95,6.46-6.9-2.61-6.9-6.46-6.9-6.46,3.08-6.46,6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m331.19,27.92h-4.89v9.15c0,3.13,1.65,4.26,3.75,4.26.74,0,1.51-.17,2.25-.43,1.46-.52,3.08.15,3.75,1.55h0c.72,1.53.05,3.36-1.49,4.03s-3.4,1.13-5.62,1.13c-6.2,0-9.38-3.52-9.38-10v-9.69h-1.84c-1.66,0-3-1.34-3-3h0c0-1.66,1.34-3,3-3h1.84v-6.13c0-1.86,1.51-3.37,3.37-3.37h0c1.86,0,3.37,1.51,3.37,3.37v6.13s4.89,0,4.89,0c1.66,0,3,1.34,3,3h0c0,1.66-1.34,3-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m364.66,34.43c0,7.55-5.76,13.18-13.57,13.18s-13.52-5.64-13.52-13.18,5.74-13.18,13.52-13.18,13.57,5.64,13.57,13.18Zm-20.21,0c0,4.06,2.84,6.9,6.64,6.9s6.67-2.84,6.67-6.9-2.87-6.9-6.67-6.9-6.64,2.84-6.64,6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m385.3,24.81v.08c-.28,1.77-1.89,3.01-3.68,2.84-.33-.03-.65-.05-.96-.05-3.13,0-5.27,1.91-5.27,5.64v10.87c0,1.86-1.51,3.37-3.37,3.37h0c-1.86,0-3.37-1.51-3.37-3.37v-19.53c0-1.77,1.44-3.21,3.21-3.21h.11c1.77,0,3.21,1.44,3.21,3.21h0c1.58-2.35,3.98-3.41,7.06-3.41.01,0,.03,0,.04,0,1.88,0,3.3,1.7,3.02,3.56Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m160.95,15.88c0-1.8-1.46-3.27-3.27-3.27s-3.27,1.46-3.27,3.27v19.33l-18.29-21.45c-.34-.4-.76-.69-1.22-.88-.02-.01-.05-.02-.08-.03-.16-.06-.32-.12-.49-.15-.06-.01-.13-.02-.2-.03-.13-.02-.27-.04-.4-.04-.04,0-.08-.01-.13-.01-.06,0-.12.01-.18.02-.1,0-.19.01-.28.03-.14.02-.28.05-.42.09-.05.01-.09.03-.14.04-.18.06-.35.13-.51.22,0,0-.02,0-.03.01-1.01.55-1.71,1.62-1.71,2.85v28.2c0,1.8,1.46,3.27,3.27,3.27s3.27-1.46,3.27-3.27v-19.37l18.32,21.49s.06.05.08.08c.1.11.2.2.31.29.07.06.13.11.2.16.12.09.25.16.38.22.07.04.13.08.2.11.16.07.33.12.5.17.04.01.09.03.13.04.22.05.44.07.68.07,0,0,0,0,0,0s0,0,0,0c.2,0,.41-.02.61-.06.07-.01.14-.04.21-.06.13-.03.25-.07.37-.12.08-.03.15-.07.23-.11.1-.05.21-.1.31-.17.08-.05.15-.1.23-.16.05-.04.11-.07.16-.11.03-.03.06-.06.09-.09.08-.08.16-.16.24-.25.07-.08.14-.15.19-.24.06-.09.12-.18.17-.27.05-.09.11-.18.15-.28.04-.09.08-.19.11-.29.04-.1.07-.2.1-.31.02-.1.04-.2.05-.3.02-.11.03-.23.03-.34,0-.04.01-.08.01-.12V15.88Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0.48,
    width: 34.02,
    height: 94.37,
    rx: 17.01,
    ry: 17.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 60.83,
    y: 0.48,
    width: 34.02,
    height: 94.37,
    rx: 17.01,
    ry: 17.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m89.87,89.87h0c-6.64,6.64-17.41,6.64-24.06,0L4.98,29.04C-1.66,22.4-1.66,11.63,4.98,4.98h0c6.64-6.64,17.41-6.64,24.06,0l60.83,60.83c6.64,6.64,6.64,17.41,0,24.06Zm4.98-72.37h0c0-9.4-7.62-17.01-17.01-17.01h0c-9.4,0-17.01,7.62-17.01,17.01h0c0,9.4,7.62,17.01,17.01,17.01h0c9.4,0,17.01-7.62,17.01-17.01Zm-60.83,60.34h0c0-9.4-7.62-17.01-17.01-17.01h0C7.62,60.83,0,68.44,0,77.84H0c0,9.4,7.62,17.01,17.01,17.01h0c9.4,0,17.01-7.62,17.01-17.01Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m134.55,86.27h-4.46v-22.41h4.46v22.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m153.97,76.39v9.87h-4.18v-8.53c0-2.24-1.12-3.47-3.02-3.47-1.79,0-3.28,1.17-3.28,3.5v8.5h-4.18v-15.51h4.07v1.82c1.1-1.65,2.8-2.24,4.56-2.24,3.52,0,6.03,2.45,6.03,6.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.38,75.08c-1.23-.61-3.2-1.25-4.95-1.27-1.58,0-2.38.56-2.38,1.41,0,.9,1.12,1.12,2.53,1.33l1.37.21c3.36.51,5.23,2.02,5.23,4.64,0,3.2-2.62,5.27-7.12,5.27-2.11,0-4.88-.4-6.9-1.82l1.65-3.17c1.33.88,2.95,1.52,5.28,1.52,1.94,0,2.87-.54,2.87-1.46,0-.75-.79-1.17-2.58-1.42l-1.27-.18c-3.59-.5-5.36-2.06-5.36-4.71,0-3.18,2.46-5.07,6.55-5.07,2.48,0,4.41.46,6.48,1.47l-1.41,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m179.24,65.69c0,1.51-1.17,2.66-2.67,2.66s-2.66-1.15-2.66-2.66,1.15-2.69,2.66-2.69,2.67,1.18,2.67,2.69Zm-.56,20.58h-4.18v-15.51h4.18v15.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m194.06,72.49v-1.73h4.1v14.23c0,4.98-3.25,7.98-8.37,7.98-2.45,0-5.04-.64-6.79-1.87l1.49-3.41c1.55,1.02,3.27,1.58,5.12,1.58,2.59,0,4.42-1.44,4.42-4.11v-1.09c-1.06,1.29-2.63,2.1-4.77,2.1-3.78,0-7.13-3.15-7.13-7.91s3.36-7.92,7.13-7.92c2.16,0,3.75.83,4.8,2.14Zm-7.65,5.78c0,2.24,1.52,4.07,3.91,4.07s3.89-1.76,3.89-4.07-1.57-4.08-3.89-4.08-3.91,1.82-3.91,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m206.75,72.42c1.1-1.54,2.76-2.08,4.45-2.08,3.52,0,6.03,2.45,6.03,6.05v9.87h-4.18v-8.53c0-2.24-1.12-3.47-3.02-3.47-1.79,0-3.28,1.17-3.28,3.5v8.5h-4.18v-23.06h4.18v9.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m232.61,74.47h-5.62v5.66c0,1.94,1.02,2.64,2.32,2.64.99,0,2.06-.5,2.91-1.01l1.53,3.27c-1.36.93-2.93,1.63-5.13,1.63-3.84,0-5.81-2.18-5.81-6.19v-6h-2.99v-3.71h2.99v-4.61h4.18v4.61h5.62v3.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m247.44,75.08c-1.23-.61-3.2-1.25-4.95-1.27-1.58,0-2.38.56-2.38,1.41,0,.9,1.12,1.12,2.53,1.33l1.37.21c3.36.51,5.23,2.02,5.23,4.64,0,3.2-2.62,5.27-7.12,5.27-2.11,0-4.88-.4-6.9-1.82l1.65-3.17c1.33.88,2.95,1.52,5.28,1.52,1.94,0,2.87-.54,2.87-1.46,0-.75-.79-1.17-2.58-1.42l-1.27-.18c-3.59-.5-5.36-2.06-5.36-4.71,0-3.18,2.46-5.07,6.55-5.07,2.48,0,4.41.46,6.48,1.47l-1.41,3.25Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumeratorInsightsLogo);
export default __webpack_public_path__ + "static/media/numerator-insights-logo.08c1ba9a2b1e74395158d80f2a012caf.svg";
export { ForwardRef as ReactComponent };